<script setup lang="ts">
import DefaultModalBase from "../DefaultModalBase.vue";
import {useModalStore} from "../../../store/modal";
import {useChatStore} from "../../../store/chat";
import {computed, onMounted, ref} from "vue";
import {useUserStore} from "../../../store/users";
import {useAuthStore} from "../../../store/auth";

const modalStore = useModalStore()
const store = useChatStore()
const userStore = useUserStore()
const authStore = useAuthStore()

const chat = ref()
const options = ref([])
const assigned_user = ref()
const users = ref([])
const isAdmin = computed(() => ['reseller-super-admin', 'reseller-team-leader', 'super-admin', 'internal-super-admin', 'internal-team-leader'].includes(authStore.user.roles[0].name))


const loading = ref(false)
const is_complete = ref(false)

const icon = computed(() => is_complete.value ? 'check-all' : 'user-single')
const heading = computed(() => chat.value?.assignee ?
    is_complete.value ?
        'Chat reassigned.' :
        'Reassign chat.'
    : is_complete.value ?
        'Chat assigned.' :
        'Assign chat.'
)
const description = computed(() => {
    const contact = chat.value?.contact ?? null;
    const client = contact ? contact?.client ?? null : null;

    return (client ? `${client.first_name} ${client.last_name} • ` : contact ? `${contact.profile_name} • ` : '') + chat.value?.phone_number
})

const assignChat = async () => {
    loading.value = true
    if (typeof modalStore.props?.id === 'object') {
        await store.bulkAssignChat(modalStore?.props?.id, assigned_user.value)
    } else {
        await store.assignChat(modalStore?.props?.id, assigned_user.value)
    }
    loading.value = false
    is_complete.value = true
}

onMounted(async () => {
    loading.value = true
    await store.getChat(modalStore?.props?.id)
    chat.value = store.chat

    await userStore.getAllUsers({all: false, role: 'internal-agent'});
    users.value = isAdmin.value ? userStore.users : [authStore.user]

    users.value.forEach(u => {
        options.value.push({
            value: u.id,
            label: `${u.first_name} ${u.last_name}`
        })
    })
    loading.value = false
})
</script>

<template>
    <DefaultModalBase :heading :icon :description :loading>
        <div class="chat-assign-container">
            <brand-button variant="secondary" v-if="is_complete" @click="modalStore.close(true)">Done</brand-button>
            <brand-form-select :label="store.chat?.assignee ?'Reassign to.' : 'Assign to.'" :options
                               v-model="assigned_user" v-if="!is_complete"/>
            <brand-button @click="assignChat()" :disabled="!assigned_user" v-if="!is_complete">
                {{ store.chat?.assignee ? "Reassign call" : "Assign call" }}
            </brand-button>
        </div>
    </DefaultModalBase>
</template>

<style scoped lang="scss">
.chat-assign-container {
    display: flex;
    flex-direction: column;
    gap: 3rem;
}
</style>
